import { apiInstance } from './client';

const setupUtilityAgentDownloadUrl =
  import.meta.env.VITE_SETUP_UTILITY_DOWNLOAD_ENDPOINT ||
  'https://downloads.robocorp.com/setup-utility/releases';

const workforceAgentDownloadUrl =
  import.meta.env.VITE_WORKFORCE_AGENT_DOWNLOAD_ENDPOINT ||
  'https://downloads.robocorp.com/workforce-agent/releases';

const assistantDownloadUrl =
  import.meta.env.VITE_ASSISTANT_DOWNLOAD_ENDPOINT ||
  'https://downloads.robocorp.com/assistant/releases/v2';

// External api
export const externalApi = apiInstance();
export const externalSetupUtilityApi = apiInstance({ url: setupUtilityAgentDownloadUrl });
export const externalWorkerApi = apiInstance({ url: workforceAgentDownloadUrl });
export const externalAssistantApi = apiInstance({ url: assistantDownloadUrl });
